var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafetyGoogles = function SvgSafetyGoogles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -134 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60 208.027 160.945 35.551L251.81 151h8.379l30.867 92.578L452 208.028V35.292C447.398 34.105 364.105 0 256 0 139.656 0 69.48 32.848 60 35.293zM482 61h30v120h-30zM0 61h30v120H0zm0 0"
  })));
};
export default SvgSafetyGoogles;